module.exports = __webpack_public_path__ + "img/ic-403.23cf9600.svg";